var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var retrieveSigningKeys = require('../utils').retrieveSigningKeys;
/**
 * Uses getKeysInterceptor to allow users to retrieve keys from a file,
 * external cache, or provided object before falling back to the jwksUri endpoint
 */


function getKeysInterceptor(client, _ref) {
  var getKeysInterceptor = _ref.getKeysInterceptor;
  var getSigningKey = client.getSigningKey.bind(client);
  return function _callee(kid) {
    var keys, signingKeys, key;
    return _regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _regeneratorRuntime.awrap(getKeysInterceptor());

          case 2:
            keys = _context.sent;

            if (keys && keys.length) {
              signingKeys = retrieveSigningKeys(keys);
            }

            if (!(signingKeys && signingKeys.length)) {
              _context.next = 8;
              break;
            }

            key = signingKeys.find(function (k) {
              return !kid || k.kid === kid;
            });

            if (!key) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", key);

          case 8:
            return _context.abrupt("return", getSigningKey(kid));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    });
  };
}

module.exports.default = getKeysInterceptor;